import type { RefObject } from "react";
import { Box, Grid } from "@mui/material";

import { AdditionalInterestCard } from "@covertree/features";

import type { AdditionalInterestType } from "@covertree/new-business-graphql";
import type { InsuredTabAdditionalInterest } from "@redux/slices/endorsement";

import { AdditionalInterestForm } from "../AdditionalInterestForm/AdditionalInterestForm";
import type { AdditionalInterestFormData } from "../types";
import { useAdditionalInterestItem } from "./useAdditionalInterestItem";

interface AdditionalInterestItemProps {
  additionalInterest: InsuredTabAdditionalInterest;
  viewOnly?: boolean;
  editingId: string | null;
  editFormRef: RefObject<HTMLDivElement>;
  interestsCountByType: Record<AdditionalInterestType, number>;
  isTenantPolicy: boolean;
  onEditClick: (id: string) => void;
  onEditClose: () => void;
  onEditSubmit: (data: AdditionalInterestFormData) => void;
  onRemoveClick: (id: string) => void;
}

export const AdditionalInterestItem = ({
  additionalInterest,
  viewOnly,
  editingId,
  editFormRef,
  interestsCountByType,
  isTenantPolicy,
  onEditClick,
  onEditClose,
  onEditSubmit,
  onRemoveClick,
}: AdditionalInterestItemProps) => {
  const { isEditing, editingFormData, actionMenuItems } =
    useAdditionalInterestItem({
      additionalInterest,
      editingId,
      onEditClick,
      onRemoveClick,
    });

  return (
    <Grid item xs={12}>
      {(!isEditing ||
        editingId !== additionalInterest.additionalInterestId) && (
        <AdditionalInterestCard
          additionalInterest={additionalInterest}
          disabled={viewOnly}
          actionMenuItems={actionMenuItems}
        />
      )}

      {isEditing && editingFormData && (
        <Box ref={editFormRef}>
          <AdditionalInterestForm
            mode={additionalInterest.isBilling ? "replace" : "edit"}
            selectedInterest={editingFormData}
            onSubmit={onEditSubmit}
            onClose={onEditClose}
            interestsCountByType={interestsCountByType}
            isTenantPolicy={isTenantPolicy}
          />
        </Box>
      )}
    </Grid>
  );
};
